import React from 'react';

import IconPhone from 'components/icons/iconPhone';
import IconMail from 'components/icons/iconMail';
import IconJoybirdSymbol from 'components/icons/iconJoybirdSymbol';
import currentYear from 'commons/currentYear';
import { colorBrand } from 'styles/layout/colors';

const CartFooter = () => (
  <footer className="flex flex-col justify-between items-center bg-white mt-8 p-8 [border-top:1px_solid_#f1f1f1] md:flex-row md:items-start lg:pl-16 min-[1440px]:pl-[13.5rem]">
    <div>
      <ul className="flex p-0 max-w-full mt-0 mx-0 mb-[25px] md:mb-0 md:p-0">
        <li className="flex list-none m-0 p-0">
          <a
            href="tel:888-282-0842"
            className="mt-0 mr-4 mb-0 ml-0 text-center flex flex-col justify-between no-underline md:text-left md:block md:mt-0 md:mr-8 md:mb-0 md:ml-0 lg:mt-0 lg:mr-12 lg:mb-0 lg:ml-0"
          >
            <div className="flex-row flex items-center">
              <div className="flex justify-center items-center min-h-[1.5rem] lg:min-h-[auto]">
                <IconPhone width={13} />
              </div>

              <div className="text-[.8125rem] tracking-[.0187rem] font-bold text-gray leading-[1.75rem] block md:inline-block lg:ml-2">
                Call us
              </div>
            </div>

            <div className="text-sm text-gray hidden md:block [&_a]:text-gray [&_a]:font-normal [&_a]:no-underline">
              888-282-0842
            </div>
          </a>
        </li>

        <li className="flex list-none m-0 p-0">
          <a
            href="mailto:support@joybird.com"
            className="mt-0 mr-4 mb-0 ml-0 text-center flex flex-col justify-between no-underline md:text-left md:block md:mt-0 md:mr-8 md:mb-0 md:ml-0 lg:mt-0 lg:mr-12 lg:mb-0 lg:ml-0"
          >
            <div className="flex flex-row items-start flex items-center">
              <div className="flex justify-center items-center min-h-[1.5rem] lg:min-h-[auto]">
                <IconMail width={16} />
              </div>
              <div className="text-[.8125rem] tracking-[.0187rem] font-bold text-gray leading-[1.75rem] block md:inline-block lg:ml-2">
                Email us
              </div>
            </div>

            <div className="text-sm text-gray hidden md:block [&_span]:text-gray [&_span]:font-normal [&_span]:no-underline">
              <span>support@joybird.com</span>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div>
      <span className="text-sm text-gray ml-2 mr-4 flex flex-row items-center">
        <span>&#169; {currentYear} Joybird, All rights reserved.</span>
        <IconJoybirdSymbol color={colorBrand} className="h-[18px] ml-5 w-6" />
      </span>
    </div>
  </footer>
);

export default CartFooter;
